import { Circle } from "@mui/icons-material";
import { Card, Typography, useTheme } from "@mui/material";
import { PieChart } from "@mui/x-charts";

type ComponentProps = {
  isTask: boolean;
  titleOverview: string;
  data: any;
};

const TotalTaskToday = ({ isTask, titleOverview, data }: ComponentProps) => {
  const theme = useTheme();

  return (
    <Card className="p-4 mb-4">
      <Typography variant="body1" className="font-semibold mb-2">
        Total {titleOverview} Today
      </Typography>

      <div className="relative flex items-center justify-center mb-2">
        <PieChart
          colors={[
            theme.vars.palette.primary.main,
            theme.vars.palette.error.main,
          ]}
          series={[
            {
              data: [
                {
                  id: 0,
                  value: isTask
                    ? data?.today?.normal_all || 0
                    : data?.today_qty?.normal_all || 0,
                },
                {
                  id: 1,
                  value: isTask
                    ? data?.today?.urgent_all || 0
                    : data?.today_qty?.urgent_all || 0,
                },
              ],
              outerRadius: 80,
              innerRadius: 65,
            },
          ]}
          width={178}
          height={178}
          margin={{ right: 4 }}
        />
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <Typography variant="h5" className="font-bold">
            {isTask
              ? (data?.today?.normal_all || 0) + (data?.today?.urgent_all || 0)
              : (data?.today_qty?.normal_all || 0) +
                (data?.today_qty?.urgent_all || 0)}
          </Typography>
          <Typography variant="body2" className="text-gray-500">
            {titleOverview}
          </Typography>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-2">
        <div className="col-span-1 flex gap-2 items-center">
          <Circle className="text-primary" />
          <Typography variant="body2" className="text-sm">
            Normal {titleOverview}:{" "}
            {isTask
              ? data?.today?.normal_all || 0
              : data?.today_qty?.normal_all || 0}
          </Typography>
        </div>
        <div className="col-span-1 flex gap-2 items-center">
          <Circle className="text-error" />
          <Typography variant="body2" className="text-sm">
            Urgent {titleOverview}:{" "}
            {isTask
              ? data?.today?.urgent_all || 0
              : data?.today_qty?.urgent_all || 0}
          </Typography>
        </div>
      </div>
    </Card>
  );
};

export default TotalTaskToday;
